import { useEffect, useState, useCallback } from 'react'

import type { IdentifierType } from 'app/common/constants/identifiers'


export default function useStatusError(
  code: string,
  identifierType: IdentifierType | null,
  createErrorText: (identifierType: IdentifierType | null, identifierCode: string) => string,
) {
  const [error, setError] = useState('')

  useEffect(() => {
    setError(createErrorText(identifierType, code))
  }, [createErrorText, code, identifierType])

  const resetError = useCallback(() => {
    setError('')
  }, [])

  return { error, resetError }
}
